import {
  FormControl as ChakraFormControl,
  FormErrorMessage as ChakraFormErrorMessage,
  FormLabel as ChakraFormLabel,
  Input as ChakraInput,
  Flex,
  Text as ChakraText,
} from '@chakra-ui/react'
import { Field as FormikField } from 'formik'
import type { FieldProps } from 'formik'
import React from 'react'
import { InfoPopover } from './InfoPopover'

interface Props {
  name: string
  placeholder: string
  label: string
  value: string
  info?: string
  description: string | React.ReactElement
  required?: boolean
  isDisabled: boolean
  handleChange(e: React.ChangeEvent): void
}

interface FormProps {
  urlPrefix: string
  desc: string
  preferenceList: string[]
}

const TextInputField = ({
  name,
  placeholder,
  label,
  value,
  info,
  description,
  handleChange,
  required,
  isDisabled,
}: Props): React.ReactElement => (
  <FormikField name={name}>
    {({ field, form }: FieldProps<string, FormProps>) => (
      <ChakraFormControl
        isInvalid={Boolean(form.errors[name] && form.touched[name])}
        isRequired={required}
      >
        <Flex direction="column">
          <Flex alignItems="baseline">
            <ChakraFormLabel htmlFor={name}>{label}</ChakraFormLabel>
            {info && <InfoPopover info={info} />}
          </Flex>

          {description && (
            <ChakraText color="#2d3748" lineHeight={1.56} paddingBottom={4}>
              {description}
            </ChakraText>
          )}
        </Flex>
        <ChakraInput
          {...field}
          id={name}
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          disabled={isDisabled}
          size="md"
        />
        <ChakraFormErrorMessage marginBottom="-2.0408em">
          {form.errors[name]}
        </ChakraFormErrorMessage>
      </ChakraFormControl>
    )}
  </FormikField>
)

export default TextInputField
